exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-073e1a0a] .el-dialog__body{padding-top:10px}.dialog-footer .el-button+.el-button[data-v-073e1a0a]{margin-left:8px}", ""]);

// exports
